import React from 'react';

class SeatSelectionFooter extends React.Component {
  render() {
    const {
      totalPrice,
      selectedCount,
      maxSeats,
      onSkip,
      onConfirm,
      canConfirm,
      checkingAvailability
    } = this.props;

    var buttonText;
    if (checkingAvailability) {
      buttonText = 'Checking availability...';
    } else if (selectedCount > 0) {
      buttonText = 'Confirm Selection';
    } else {
      buttonText = 'Select ' + (maxSeats - selectedCount) + ' more seat' + (maxSeats - selectedCount !== 1 ? 's' : '');
    }

    return (
      <div className="seat-selection-footer">
        <div className="total-section">
          <span className="total-label">Seat Add-on:</span>
          <span className="total-amount">${totalPrice.toFixed(2)}</span>
        </div>
        <div className="action-buttons">
          {selectedCount === 0 && !checkingAvailability && (
            <button
              className="btn-skip"
              onClick={onSkip}
            >
              Skip
            </button>
          )}
          <button
            className="btn-confirm"
            onClick={onConfirm}
            disabled={!canConfirm}
          >
            {buttonText}
          </button>
        </div>
      </div>
    );
  }
}

export default SeatSelectionFooter;
